import { render, staticRenderFns } from "./configure-ui.vue?vue&type=template&id=20a3f2d2&scoped=true&"
import script from "./configure-ui.vue?vue&type=script&lang=ts&"
export * from "./configure-ui.vue?vue&type=script&lang=ts&"
import style0 from "./configure-ui.vue?vue&type=style&index=0&id=20a3f2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a3f2d2",
  null
  
)

export default component.exports